export const BASE = {
  1: '0x3A9FfF453d50D4Ac52A6890647b823379ba36B9E'
}

export const FACTORY_ADDRESSES = {
  1: '0xc0a47dFe034B400B47bDaD5FecDa2621de6c4d95',
  3: '0x9c83dCE8CA20E9aAF9D3efc003b2ea62aBC08351',
  4: '0xf5D915570BC477f9B8D6C0E980aA81757A3AaC36',
  42: '0xD3E51Ef092B2845f10401a0159B2B96e8B6c3D30'
}

export const MULTICALL_ADDRESS = {
  1: '0xeefba1e63905ef1d7acba5a8513c70307c1ce441',
  3: 'TODO this'
}

export const DEFSWAP_FACTORY_ADDRESSES = {
  1: '0xfb02641a0752b4d53dabb8b2d75c92c1858a7a4e',
  3: '0x1a9b1cfbf556ac0aff1746cec07a907901a3b3e6'
}

export const SUPPORTED_THEMES = {
  DARK: 'DARK',
  LIGHT: 'LIGHT'
}
